import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import Footer from "../../Components/Common/Footer";
import SearchList from "../../Components/SearchList/SearchList";

class SearchListPage extends Component {
  constructor({ match }) {
    super();
    this.state = {
      code: match.params.code,
    };
  }

  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <SearchList code={this.state.code} />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default SearchListPage;
